import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { UiIcon } from 'ui-components';
import { StyledUiAccordion } from './UiAccordion.styles';

const UiAccordion = ({ list, defaultExpanded }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <StyledUiAccordion>
      <div className='ui-accordion'>
        {list?.map((item, index) => (
          <Accordion
            key={item?.title?.replace(' ', '_') || index}
            expanded={expanded === index}
            onChange={handleChange(index)}
            disableGutters
            elevation={0}
            square
            sx={{
              backgroundColor: 'unset',
            }}
          >
            <AccordionSummary
              expandIcon={
                <UiIcon icon='ri-arrow-down-s-line' color='#9CAEBB' size={18} />
              }
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              sx={{
                padding: '0',
              }}
            >
              {item?.title}
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '8px 0 16px 32px !important',
                textAlign: 'justify',
              }}
            >
              {item?.description}

              {item?.image && (
                <>
                  <br></br>
                  <img src={item?.image} className='accordion-image' />
                </>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </StyledUiAccordion>
  );
};

UiAccordion.propTypes = {
  list: PropTypes.array,
  defaultExpanded: PropTypes.oneOf([PropTypes.number, false]),
};

export default UiAccordion;
